export default Object.freeze({
  list: [],
  excel: [],
  stats: {},
  hasMore: true,
});
